import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import * as utils from "../../utils/utils";
import * as cookies from "../../utils/cookies";
import * as models from "../../models";
import * as modelsGet from "../../models/get";
import * as modelsPost from "../../models/post";
import * as modelsForm from "../../models/form";
import * as apiAccounts from "../../api/accounts";
import * as apiTemplates from "../../api/templates";
import * as apiEvents from "../../api/events";
import * as apiCalendars from "../../api/calendars";
import * as apiSubjects from "../../api/subjects";
import * as apiStatus from "../../api/status";
import * as apiLabels from "../../api/labels";
import * as apiDisplayTypes from "../../api/displayTypes";
import * as apiBurialMethods from "../../api/burialMethods";
import * as apiGraveTypes from "../../api/graveTypes";
import * as apiPersons from "../../api/persons";
import * as apiDenominations from "../../api/denominations";
import { InputValueType } from "../../enumerations";
import { Flyout } from "../flyout";
import { FormGroup } from "../form";
import { Table, CheckColumn, ITableColumn, ITableRowEventArgs } from "../table";
import { PopupProvider, Popup, PopupTrigger } from "../popup";
import { ContextMenu, MenuItem, Separator } from "../contextmenu/index";
import Inputmask from "inputmask";
import { InputSideButton, InputMask, InputSize } from "../input";
import { TextBox } from "../textBox";
import { ComboBox, DropDownTextItem, ComboBoxType, DROPDOWN_TEXT_ITEM_HEIGHT } from "../comboBox";
import { ToolBar, ToolBarItem, ToolBarSeparator } from "../toolbar";
import { Loader, LoaderStyle } from "../loader";
import { CheckBox } from "../checkbox";


interface IProperties
{
    show: boolean;
    onClose: () => void;
    onGotoEvent?: (evt: modelsGet.IEvent) => void;
    onOpenEvent?: (evt: modelsGet.IEvent) => void;
}

interface IState
{
    isSearching: boolean;
    showExtendedSearch: boolean;
    events?: modelsGet.IEvent[];
    selectedEvent?: modelsGet.IEvent;
    error?: string;
    form: {
        titleDeceased?: string;
        firstnameDeceased?: string;
        lastnameDeceased?: string;
        birthnameDeceased?: string;
        streetDeceased?: string;
        streetNoDeceased?: string;
        countryDeceased?: string;
        zipCodeDeceased?: string;
        cityDeceased?: string;
        dateOfBirth?: string;
        dateOfDeath?: string;
        startdate?: string;
        starttime?: string;
        enddate?: string;
        endtime?: string;
        graveNo?: string;
        showArchivedEvents?: boolean;
        denominationIds?: string[];
        calendarIds?: string[];
        subjectIds?: string[];
        statusIds?: string[];
        displayTypeIds?: string[];
        burialMethodIds?: string[];
        graveTypes?: string[];
        mortician?: modelsForm.IComboBoxValue<string, number>;
        eventId?: number;
        funeralGuestsCount?: number;
    }
}

export class Search extends React.Component<IProperties, IState>
{
    private _currentUser: modelsGet.IUser;
    private _denominationOptions: modelsGet.IDenomination[];
    private _calendarOptions: modelsGet.ICalendar[];
    private _subjectOptions: modelsGet.ISubject[];
    private _statusOptions: modelsGet.IStatus[];
    private _displayTypeOptions: modelsGet.IDisplayType[];
    private _burialMethodOptions: modelsGet.IBurialMethod[];
    private _graveTypeOptions: modelsGet.IGraveType[];
    private _morticianOptions: modelsGet.IPerson[];
    private _templates: modelsGet.ITemplate[];

    constructor(props)
    {
        super(props);
        this.initAsync(props);
    }

    /**
     * Initialisiert die Suche.
     * @param props Die Eigenschaften dieser Komponente.
     */
    private async initAsync(props: IProperties)
    {
        // State Standardwerte vergeben.
        this.state = {
            isSearching: false,
            showExtendedSearch: false,
            form: {
                mortician: {}
            }
        };

        this._currentUser = await apiAccounts.getCurrentUser();
        this._denominationOptions = await apiDenominations.getDenominations();
        this._calendarOptions = await apiCalendars.getCalendars();
        this._subjectOptions = await apiSubjects.getSubjects();
        this._statusOptions = await apiStatus.getStatus();
        this._displayTypeOptions = await apiDisplayTypes.getDisplayTypes();
        this._burialMethodOptions = await apiBurialMethods.getBurialMethods();
        this._graveTypeOptions = await apiGraveTypes.getGraveTypes();
        this._morticianOptions = await apiPersons.getMorticians();
        this._templates = await apiTemplates.getTemplates();
        this._templates = (this._templates || []).where(t => !this._currentUser.claims.forbidden_reports.contains(t.id));
    }

    ///**
    // * Wird ausgeführt wenn die Komponente das erste mal im DOM verankert wird.
    // */
    //componentDidMount()
    //{
    //    // Die Sucheinträge der zuletzt getätigten Suche laden.
    //    var userInput = cookies.getJSON<modelsPost.ISearch>("SRC_INP", true);
    //    if (userInput != null)
    //    {
    //        var form = {
    //            titleDeceased: userInput.deceased_title,
    //            firstnameDeceased: userInput.deceased_firstname,
    //            lastnameDeceased: userInput.deceased_lastname,
    //            birthnameDeceased: userInput.deceased_birthname,
    //            streetDeceased: userInput.deceased_street,
    //            streetNoDeceased: userInput.deceased_street_no,
    //            countryDeceased: userInput.deceased_country,
    //            zipCodeDeceased: userInput.deceased_zip_code,
    //            cityDeceased: userInput.deceased_city,
    //            dateOfBirth: (userInput.deceased_date_of_birth != null) ? moment(userInput.deceased_date_of_birth).format("L") : null,
    //            dateOfDeath: (userInput.deceased_date_of_death != null) ? moment(userInput.deceased_date_of_death).format("L") : null,
    //            startdate: (userInput.startdate != null) ? moment(userInput.startdate).format("L") : null,
    //            starttime: userInput.time_start,
    //            enddate: (userInput.enddate != null) ? moment(userInput.enddate).format("L") : null,
    //            endtime: userInput.time_end,
    //            graveNo: userInput.grave_no,
    //            showArchivedEvents: userInput.show_archived_events,
    //            denominationIds: (userInput.deceased_denomination_ids != null && userInput.deceased_denomination_ids.length > 0) ? userInput.deceased_denomination_ids.select(d => d.toString()) : null,
    //            calendarIds: (userInput.calendar_ids != null && userInput.calendar_ids.length > 0) ? userInput.calendar_ids.select(c => c.toString()) : null,
    //            subjectIds: (userInput.subject_ids != null && userInput.subject_ids.length > 0) ? userInput.subject_ids.select(s => s.toString()) : null,
    //            statusIds: (userInput.status_ids != null && userInput.status_ids.length > 0) ? userInput.status_ids.select(s => s.toString()) : null,
    //            displayTypeIds: (userInput.display_type_ids != null && userInput.display_type_ids.length > 0) ? userInput.display_type_ids.select(d => d.toString()) : null,
    //            burialMethodIds: (userInput.burial_method_ids != null && userInput.burial_method_ids.length > 0) ? userInput.burial_method_ids.select(d => d.toString()) : null,
    //            graveTypes: userInput.grave_types,
    //            morticianIds: (userInput.mortician_ids != null && userInput.mortician_ids.length > 0) ? userInput.mortician_ids.select(m => m.toString()) : null,
    //            funeralGuestsCount: userInput.;
    //        };

    //        this.setState({
    //            form: form
    //        }, this.startSearchWhenMounted.bind(this));
    //    }
    //}

    /**
     * Startet die Suche.
     */
    private async startSearch(): Promise<modelsGet.IEvent[]>
    {
        try
        {
            var { form } = this.state;
            var startdate: moment.Moment = moment(form.startdate, "DD.MM.YYYY");
            var enddate: moment.Moment = moment(form.enddate, "DD.MM.YYYY");
            var deceasedDateOfBirth: moment.Moment = moment(form.dateOfBirth, "DD.MM.YYYY");
            var deceasedDateOfDeath: moment.Moment = moment(form.dateOfDeath, "DD.MM.YYYY");

            var userInput: modelsPost.ISearch = {
                calendar_ids: utils.parseArray<number>(form.calendarIds),
                subject_ids: utils.parseArray<number>(form.subjectIds),
                status_ids: utils.parseArray<number>(form.statusIds),
                display_type_ids: utils.parseArray<number>(form.displayTypeIds),
                startdate: ((startdate.isValid()) ? startdate.format() : undefined),
                time_start: form.starttime,
                enddate: ((enddate.isValid()) ? enddate.format() : undefined),
                time_end: form.endtime,
                burial_method_ids: utils.parseArray<number>(form.burialMethodIds),
                grave_types: form.graveTypes,
                grave_no: form.graveNo,
                mortician_ids: form.mortician.selectedValue != null ? [form.mortician.selectedValue] : undefined,
                deceased_title: form.titleDeceased,
                deceased_firstname: form.firstnameDeceased,
                deceased_birthname: form.birthnameDeceased,
                deceased_lastname: form.lastnameDeceased,
                deceased_street: form.streetDeceased,
                deceased_street_no: form.streetNoDeceased,
                deceased_country: form.countryDeceased,
                deceased_zip_code: form.zipCodeDeceased,
                deceased_city: form.cityDeceased,
                deceased_date_of_birth: ((deceasedDateOfBirth.isValid()) ? deceasedDateOfBirth.format() : undefined),
                deceased_date_of_death: ((deceasedDateOfDeath.isValid()) ? deceasedDateOfDeath.format() : undefined),
                deceased_denomination_ids: utils.parseArray<number>(form.denominationIds),
                show_archived_events: form.showArchivedEvents,
                event_id: form.eventId,
                funeral_guests_count: form.funeralGuestsCount
            };
            var events: modelsGet.IEvent[] = await apiEvents.postSearch(userInput);

            if (!this._currentUser.claims.can_see_all_events)
            {
                events.removeAt((event): boolean => 
                {
                    if (event.user_id !== this._currentUser.id)
                    {
                        if (this._currentUser.mortician_id > 0 && (event.persons != null && event.persons.length > 0))
                        {
                            var mortician = event.persons.where(p => p.is_mortician).first();
                            if (mortician != null && mortician.id === this._currentUser.mortician_id)
                                return false;
                        }

                        return true;
                    }
                });
            }

            this.setState({
                selectedEvent: null
            });
            return events;
        }
        catch (e)
        {
            console.log(e);
        }
    }

    /**
     * Wenn ausgeführt wenn auf den Suchen Button geklickt wird.
     */
    private async onSearchButtonClick()
    {
        this.setState({
            isSearching: true
        });

        var events: modelsGet.IEvent[] = await this.startSearch();

        this.setState({
            isSearching: false,
            events: events
        });
    }

    /**
     * Leert alle Felder.
     */
    private onClearFieldsButtonClick(): void
    {
        this.setState({
            form: {
                ...this.state.form,
                lastnameDeceased: "",
                firstnameDeceased: "",
                birthnameDeceased: "",
                dateOfBirth: "",
                dateOfDeath: "",
                startdate: "",
                starttime: "",
                enddate: "",
                endtime: "",
                denominationIds: [],
                calendarIds: [],
                subjectIds: [],
                statusIds: [],
                displayTypeIds: [],
                burialMethodIds: [],
                graveTypes: [],
                mortician: {},
                graveNo: "",
                showArchivedEvents: false,
                eventId: null,
                funeralGuestsCount: null,
            }
        });
    }

    /**
     * Zeigt die erweiterte Suche an.
     */
    private onShowExtendedSearchLinkButtonClick(): void
    {
        if (this.state.showExtendedSearch)
        {
            this.setState({
                showExtendedSearch: false
            });
        }
        else
        {
            this.setState({
                showExtendedSearch: true
            });
        }
    }

    /**
     * Aktualisiert die momentane Ergebnis.
     */
    private async onRefreshButtonClick()
    {
        var events: modelsGet.IEvent[] = await this.startSearch();
        this.setState({
            events: events
        });
    }

    /**
     * Wird ausgeführt sobald auf eine Zeile geklickt wird. Die Daten der ausgewählten
     * Zeile werden hier für weitere Zwecke zwischengespeichert.
     * @param e
     */
    private onTableRowClick(e: ITableRowEventArgs<modelsGet.IEvent>)
    {
        this.setState({
            selectedEvent: e.dataSource
        });
    }

    /**
     * Bei einem Doppelklick auf einen Zeile, soll der ausgewählte Termin im Kalender
     * angezeigt werden.
     * @param e Das auslösende Ereignis.
     */
    private onTableRowDoubleClick(e: ITableRowEventArgs<modelsGet.IEvent>)
    {
        this.setState({
            selectedEvent: e.dataSource
        });

        if (!e.dataSource.is_archived)
        {
            this.gotoEvent(e.dataSource);
            this.props.onClose && this.props.onClose();
        }
    }

    /**
     * Das Kontextmenü des Browsers darf bei einem Rechtsklick auf eine Zeile in der Liste nicht
     * angezeigt werden. Daher wird es hier abgeschaltet.
     * Der <ContextMenuProvider /> kann das zwar auch, aber bei diesem speziellen Fall muss
     * es manuell erfolgen.
     * @param e Das auslösende Ereignis.
     */
    private onTableRowRightClick(e: ITableRowEventArgs<modelsGet.IEvent>)
    {
        this.setState({
            selectedEvent: e.dataSource
        });
        e.event.preventDefault();
    }

    /**
     * Öffent einen Report.
     * @param e
     * @param value Der Report der geöffnet werden soll.
     */
    private onOpenReportMenuItemClick(template: modelsGet.ITemplate)
    {
        if (template.is_list)
        {
            window.open(
                `/templates?report=${template.name}`,
                "_blank"
            );
        }
        else
        {
            window.open(
                `/templates?report=${template.name}&eventId=${this.state.selectedEvent.id}`,
                "_blank"
            );
        }
    }

    /**
     * ContextMenu Event: Springt zum Kalender und Zeitraum des ausgewählten Termins.
     */
    private onGotoEventMenuItemClick()
    {
        this.gotoEvent(this.state.selectedEvent);
        this.props.onClose && this.props.onClose();
    }

    /**
     * ContextMenu Event: Öffnet den ausgewählten Termin.
     */
    private onOpenEventMenuItemClick()
    {
        this.openEvent(this.state.selectedEvent);
    }

    /**
     * Das Kontextmenü darf nicht geöffnet werden wenn die rechte Maustaste auf dem
     * Header oder der Seitennummerierung betätigt wurde.
     * @param e
     */
    private onContextMenuOpening(e: MouseEvent): boolean
    {
        var pos = utils.getMousePosition(e);
        var elem = document.elementFromPoint(pos.x, pos.y);
        return $(elem).closest(".n-table").length > 0;
    }

    /**
     * Springt zum Kalender und Datum des übergebenen Termins.
     * @param event Der Termin der angezeigt werden soll.
     */
    private gotoEvent(event: modelsGet.IEvent)
    {
        this.props.onGotoEvent && this.props.onGotoEvent(event);
    }

    /**
     * Öffnet den übergebenen Termin.
     * @param event Der Termin der geöffnet werden soll.
     */
    private openEvent(event: modelsGet.IEvent)
    {
        this.props.onOpenEvent && this.props.onOpenEvent(event);
    }

    /**
     * Wird ausgelöst sobald der sich der Wert einer ComboBox oder einer CheckBox ändert.
     * @param event
     */
    private handleChange(e: Event)
    {
        var name: string = (e.target as HTMLInputElement).name;
        var type: string = (e.target as HTMLInputElement).type;
        var value: any;

        if (type === "select-multiple")
        {
            let target = e.target as HTMLSelectElement;
            let selectedOptions: JQuery<any> = $(target).find("option:selected");

            if (selectedOptions.length > 0)
            {
                value = [];
                for (var i = 0; i < selectedOptions.length; i++)
                {
                    var selectedVal: string = selectedOptions[i].value;
                    if (selectedVal !== "--")
                    {
                        value.push(selectedOptions[i].value);
                    }
                }
            }
        }
        else if (type === "checkbox")
        {
            let target = e.target as HTMLInputElement;
            value = target.checked;
        }
        else
        {
            let target = e.target as HTMLInputElement;
            value = target.value;
        }

        this.setState({
            form: {
                ...this.state.form,
                [name]: value,
            },
        });
    }

    /**
     * Wird ausgelöst, sobald sich der Wert einer TextBox ändert.
     */
    private onTextBoxChanged(value: any[], originalValue: string[], name: string)
    {
        this.setState((state: IState) =>
        {
            state.form[name] = value[0];
            return state;
        });
    }

    /**
     * Wird ausgeführt, sobald sich der Wert einer ComboBox ändert.
     * @param selectedItem Das neu selektierte Item.
     * @param valueName Der Property Name für den "value" Wert.
     * @param selectedValueName Der Property Name für den "selectedValue" Wert.
     * @param formItemName Der Name des Form Elements.
     */
    private onComboBoxChanged = (selectedItem: any, valueName: string, selectedValueName: string, formItemName: string) =>
    {
        this.setState((state: IState) =>
        {
            state.form[formItemName] = {
                value: selectedItem[valueName],
                selectedValue: selectedItem[selectedValueName]
            };
            return state;
        });
    }

    /**
     * Entfernt die Selektion einer ComboBox.
     * @param formItemName Der Name des Form Elements.
     */
    private clearComboBoxValue = (formItemName: string) =>
    {
        this.setState((state: IState) =>
        {
            state.form[formItemName] = {};
            return state;
        });
    }

    /**
     * Wird ausgeführt, sobald sich der Wert einer CheckBox ändert.
     * @param e Das auslösende Ereignis.
     */
    private onCheckboxChanged = (e: React.ChangeEvent<HTMLInputElement>) =>
    {
        var target = e.target;
        var value = target.checked;

        this.setState((state: IState) =>
        {
            state.form.showArchivedEvents = value;
            return state;
        });
    }

    /**
     * Setzt eine Maske bei einem input Element.
     * @param ref
     */
    private setInputMask(ref: HTMLElement)
    {
        if (ref != null)
        {
            Inputmask().remove(ref);
            Inputmask({
                showMaskOnHover: false
            }).mask(ref);
        }
    }

    /**
     * Erstellt die Hinweis Komponente.
     */
    private getAlert()
    {
        var { form, showExtendedSearch } = this.state;
        var renderAlert: boolean = false;

        if (form.denominationIds != null && form.denominationIds.length > 0)
            renderAlert = true;

        if (form.calendarIds != null && form.calendarIds.length > 0)
            renderAlert = true;

        if (form.subjectIds != null && form.subjectIds.length > 0)
            renderAlert = true;

        if (form.statusIds != null && form.statusIds.length > 0)
            renderAlert = true;

        if (form.displayTypeIds != null && form.displayTypeIds.length > 0)
            renderAlert = true;

        if (form.burialMethodIds != null && form.burialMethodIds.length > 0)
            renderAlert = true;

        if (form.graveTypes != null && form.graveTypes.length > 0)
            renderAlert = true;

        if (form.mortician.selectedValue != null)
            renderAlert = true;

        if (form.graveNo != null && form.graveNo !== "")
            renderAlert = true;

        if (form.showArchivedEvents)
            renderAlert = true;

        if (form.eventId)
            renderAlert = true;

        if (form.funeralGuestsCount)
            renderAlert = true;

        if (renderAlert && !showExtendedSearch)
        {
            return <div className="alert alert--warning">Es sind noch erweiterte Suchparameter angegeben.</div>;
        }
    }

    /**
     * Erstellt die Komponente für das Suchergebnis.
     */
    private getList()
    {
        if (this.state.events != null && this.state.events.length > 0)
        {
            const columns: ITableColumn[] = [
                {
                    header: "ID",
                    accessor: "id",
                    width: 60
                },
                {
                    header: "Betreff",
                    accessor: "subject",
                    width: 200
                },
                {
                    header: "Datum",
                    computedValue: (data: modelsGet.IEvent) =>
                    {
                        return moment(data.starttime).format("dd L HH:mm") + ' - ' + moment(data.endtime).format("HH:mm");
                    }
                },
                {
                    header: "Kalender",
                    accessor: "calendar_name"
                },
                {
                    header: "Grabart",
                    accessor: "grave_type"
                },
                {
                    header: "Verstorbener",
                    computedValue: (data: modelsGet.IEvent) =>
                    {
                        if (data != null && data.persons != null && data.persons.length > 0)
                        {
                            let deceased: modelsGet.IPerson = data.persons.where(p => p.is_deceased).first();
                            if (deceased != null)
                                return deceased.fullname_and_address_without_title;
                        }

                        return "";
                    },
                    width: 200
                },
                {
                    header: "Bestatter",
                    computedValue: (data: modelsGet.IEvent) =>
                    {
                        if (data != null && data.persons != null && data.persons.length > 0)
                        {
                            let mortician: modelsGet.IPerson = data.persons.where(p => p.is_mortician).first();
                            if (mortician != null)
                                return mortician.fullname_and_address_without_title;
                        }

                        return "";
                    },
                    width: 300
                },
                {
                    header: "Ist archiviert",
                    cell: (user: modelsGet.IEvent) => <CheckColumn isChecked={user.is_archived} width={100} />,
                    width: 150
                }
            ];

            return (
                <div className="fo-search_table-container">
                    <PopupProvider
                        id="list-contextmenu"
                        onOpening={this.onContextMenuOpening.bind(this)}>
                        <Table
                            dataSource={this.state.events}
                            columns={columns}
                            keyAccessor="id"
                            onRowClick={this.onTableRowClick.bind(this)}
                            onRowDoubleClick={this.onTableRowDoubleClick.bind(this)}
                            onRowRightClick={this.onTableRowRightClick.bind(this)} />
                    </PopupProvider>
                </div>
            );
        }
        else
        {
            return <span className="fo-search_no-result">Die Suche ergab kein Ergebnis. Ändern Sie Ihre Suchparameter und versuchen Sie es erneut.</span>
        }
    }

    /**
     * Erstellt die Auswahlmöglichkeiten für eine ComboBox.
     * @param value Der Name der Eigenschaft die den Wert der Option wiedergibt.
     * @param text Der Name der Eigenschaft die den Anzeigetext wiedergibt.
     * @param options Die Optionen anhand dessen Die Auswahlmöglichkeiten generiert werden sollen.
     */
    private getOptions(value: string, text: string, options: any[])
    {
        var returnValue: any[] = options.map((option) =>
            <option value={option[value]}>{option[text]}</option>
        );

        returnValue.unshift(<option>--</option>);
        return returnValue;
    }

    /**
     * Erstellt die MenuItems für das "Reports" Kontextmenü.
     */
    private getTemplates()
    {
        var templates = [];
        if (this._templates != null && this._templates.length > 0)
        {
            var isMortician: boolean = this._currentUser.mortician_id > 0;
            var reports: modelsGet.ITemplate[] = (isMortician) ? null : this._templates.where(t => !t.is_list);
            var lists: modelsGet.ITemplate[] = this._templates.where(t => t.is_list);

            if (reports != null && reports.length > 0)
            {
                for (let report of reports)
                {
                    templates.push(
                        <MenuItem
                            icon="file"
                            header={report.display_name}
                            dataSource={report}
                            onClick={this.onOpenReportMenuItemClick.bind(this)}
                            isDisabled={this.state.selectedEvent == null || this.state.selectedEvent.is_archived} />
                    );
                }

                templates.push(
                    <Separator />
                );
            }

            if (lists != null && lists.length > 0)
            {
                for (let list of lists)
                {
                    templates.push(
                        <MenuItem
                            icon="file-document"
                            header={list.display_name}
                            dataSource={list}
                            onClick={this.onOpenReportMenuItemClick.bind(this)} />
                    );
                }
            }
        }

        return templates;
    }

    /**
     * Rendert die Suche.
     */
    render()
    {
        if (!this.props.show)
            return null;

        const { isSearching, showExtendedSearch, form } = this.state;
        const templateCount = (this._templates || []).where(t => t.is_list).length;

        var extendedSearch = [];
        if (showExtendedSearch)
        {
            extendedSearch.push(
                <div className="input-group-h-wrapper">
                    <div className="input-group">
                        <label htmlFor="denominationIds">Konfession</label>
                        <select
                            id="denominationIds"
                            name="denominationIds"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.denominationIds}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("id", "denomination", this._denominationOptions)}>
                        </select>
                    </div>
                    <div className="input-group">
                        <label htmlFor="calendarIds">Kalender</label>
                        <select
                            id="calendarIds"
                            name="calendarIds"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.calendarIds}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("id", "name", this._calendarOptions)}>
                        </select>
                    </div>
                    <div className="input-group">
                        <label htmlFor="subjectIds">Betreff</label>
                        <select
                            id="subjectIds"
                            name="subjectIds"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.subjectIds}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("id", "subject", this._subjectOptions)}>
                        </select>
                    </div>
                    <div className="input-group">
                        <label htmlFor="statusIds">Status</label>
                        <select
                            id="statusIds"
                            name="statusIds"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.statusIds}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("id", "status", this._statusOptions)}>
                        </select>
                    </div>
                </div>
            );

            var morticianSelect = null;
            //if (!(this._currentUser.mortician_id > 0))
            //{
            //    morticianSelect = (
            //        <div className="input-group">
            //            <label htmlFor="morticianIds">Bestatter</label>
            //            <select
            //                id="morticianIds"
            //                name="morticianIds"
            //                className="input input--multiselect"
            //                multiple={true}
            //                size={5}
            //                value={form.morticianIds}
            //                onChange={this.handleChange.bind(this)}>
            //                {this.getOptions("id", "fullname_and_address_without_title", this._morticianOptions)}>
            //            </select>
            //        </div>
            //    );
            //}

            extendedSearch.push(
                <div className="input-group-h-wrapper">
                    <div className="input-group">
                        <label htmlFor="displayTypeIds">Anzeigearten</label>
                        <select
                            id="displayTypeIds"
                            name="displayTypeIds"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.displayTypeIds}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("id", "text", this._displayTypeOptions)}>
                        </select>
                    </div>
                    <div className="input-group">
                        <label htmlFor="burialMethodIds">Bestattungsarten</label>
                        <select
                            id="burialMethodIds"
                            name="burialMethodIds"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.burialMethodIds}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("id", "method", this._burialMethodOptions)}>
                        </select>
                    </div>
                    <div className="input-group">
                        <label htmlFor="graveTypes">Grabarten</label>
                        <select
                            id="graveTypes"
                            name="graveTypes"
                            className="input input--multiselect"
                            multiple={true}
                            size={5}
                            value={form.graveTypes}
                            onChange={this.handleChange.bind(this)}>
                            {this.getOptions("type_long", "type_long", this._graveTypeOptions)}>
                        </select>
                    </div>
                </div>
            );

            extendedSearch.push(
                <FormGroup>
                    <TextBox
                        placeholder="Termin ID"
                        mask={InputMask.number}
                        size={InputSize.small}
                        valueType={InputValueType.number}
                        value={(form.eventId != null && form.eventId > 0) ? form.eventId.toString() : null}
                        onTextChange={(value, originalValue) => this.onTextBoxChanged(value, originalValue, "eventId")} />
                </FormGroup>
            );

            extendedSearch.push(
                <FormGroup>
                    <TextBox
                        placeholder="Anzahl Trauergäste"
                        mask={InputMask.number}
                        size={InputSize.small}
                        valueType={InputValueType.number}
                        value={(form.funeralGuestsCount != null && form.funeralGuestsCount >= 0) ? form.funeralGuestsCount.toString() : null}
                        onTextChange={(value, originalValue) => this.onTextBoxChanged(value, originalValue, "funeralGuestsCount")} />
                </FormGroup>
            );

            extendedSearch.push(
                <FormGroup>
                    <TextBox
                        placeholder="Grabnummer"
                        size={InputSize.small}
                        value={form.graveNo}
                        onTextChange={(value, originalValue) => this.onTextBoxChanged(value, originalValue, "graveNo")} />
                </FormGroup>
            );

            if(!(this._currentUser.mortician_id > 0))
            {
                extendedSearch.push(
                    <ComboBox
                        canRemoveSelection={true}
                        placeholder="Bestatter"
                        dataSource={this._morticianOptions}
                        dropDownMenuItemHeight={DROPDOWN_TEXT_ITEM_HEIGHT}
                        comboBoxType={ComboBoxType.dropDownList}
                        value={form.mortician.value}
                        selectedValue={form.mortician.selectedValue}
                        onSelectionChanged={(data) => this.onComboBoxChanged(data, "fullname_and_address_without_title_rev", "id", "mortician")}
                        valueMember="id"
                        displayMember="fullname_and_address_without_title_rev"
                        sideButtons={[
                            <InputSideButton
                                icon="close"
                                onClick={() => this.clearComboBoxValue("mortician")} />
                        ]}>
                        {
                            (item: modelsGet.IPerson) =>
                            {
                                return (
                                    <DropDownTextItem
                                        key={item.id}
                                        value={item.id}
                                        displayValue={item.fullname_and_address_without_title_rev} />
                                );
                            }
                        }
                    </ComboBox>
                );
            }

            extendedSearch.push(
                <CheckBox
                    label="Gelöschte Termine berücksichtigen."
                    isChecked={form.showArchivedEvents}
                    onCheckedChanged={this.onCheckboxChanged} />
            );
        }

        return (
            <div>
                <Flyout
                    isOpen={this.props.show}
                    width={1080}
                    headerText="Suche"
                    alignRight
                    onClose={this.props.onClose}>
                    <div className="fo-search">
                        {this.getAlert()}
                        <form autoComplete="off">
                            <div className="input-group-h-wrapper">
                                <div className="input-group">
                                    <input
                                        name="lastnameDeceased"
                                        className="input"
                                        placeholder="Nachname (Verstorbener)"
                                        type="text"
                                        value={form.lastnameDeceased}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                                <div className="input-group">
                                    <input
                                        name="firstnameDeceased"
                                        className="input"
                                        placeholder="Vorname (Verstorbener)"
                                        type="text"
                                        value={form.firstnameDeceased}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                                <div className="input-group">
                                    <input
                                        name="birthnameDeceased"
                                        className="input"
                                        placeholder="Geburtsname (Verstorbener)"
                                        type="text"
                                        value={form.birthnameDeceased}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                            </div>
                            <div className="input-group-h-wrapper">
                                <div className="input-group">
                                    <input
                                        ref={this.setInputMask.bind(this)}
                                        name="dateOfBirth"
                                        className="input"
                                        type="text"
                                        placeholder="Geburtsdatum"
                                        data-inputmask-alias="dd.mm.yyyy"
                                        value={form.dateOfBirth}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                                <div className="input-group">
                                    <input
                                        ref={this.setInputMask.bind(this)}
                                        name="dateOfDeath"
                                        className="input"
                                        type="text"
                                        placeholder="Sterbedatum"
                                        data-inputmask-alias="dd.mm.yyyy"
                                        value={form.dateOfDeath}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                            </div>
                            <div className="input-group-h-wrapper">
                                <div className="input-group">
                                    <input
                                        ref={this.setInputMask.bind(this)}
                                        name="startdate"
                                        className="input"
                                        type="text"
                                        placeholder="Startdatum"
                                        data-inputmask-alias="dd.mm.yyyy"
                                        value={form.startdate}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                                <div className="input-group">
                                    <input
                                        ref={this.setInputMask.bind(this)}
                                        name="starttime"
                                        className="input"
                                        type="text"
                                        placeholder="Uhrzeit"
                                        data-inputmask-alias="hh:mm"
                                        value={form.starttime}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                                <div className="input-group">
                                    <input
                                        ref={this.setInputMask.bind(this)}
                                        name="enddate"
                                        className="input"
                                        type="text"
                                        placeholder="Endedatum"
                                        data-inputmask-alias="dd.mm.yyyy"
                                        value={form.enddate}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                                <div className="input-group">
                                    <input
                                        ref={this.setInputMask.bind(this)}
                                        name="endtime"
                                        className="input"
                                        type="text"
                                        placeholder="Uhrzeit"
                                        data-inputmask-alias="hh:mm"
                                        value={form.endtime}
                                        onChange={this.handleChange.bind(this)}
                                        spellCheck={false} />
                                </div>
                            </div>
                            {extendedSearch}
                            <div className="fo-search_actions">
                                <button
                                    className="btn btn--primary btn--small"
                                    type="button"
                                    onClick={this.onSearchButtonClick.bind(this)}>Suchen</button>
                                <button
                                    className="btn btn--default btn--small"
                                    type="button"
                                    onClick={this.onClearFieldsButtonClick.bind(this)}>Felder leeren</button>
                                <a
                                    className="btn-link btn-link--no-icon"
                                    onClick={this.onShowExtendedSearchLinkButtonClick.bind(this)}>Erweiterte Suche {(this.state.showExtendedSearch) ? "ausblenden" : "einblenden"}</a>
                            </div>
                        </form>
                        <ToolBar>
                            <ToolBarItem
                                icon="refresh"
                                isDisabled={this.state.events == null || this.state.events.length === 0}
                                onClick={this.onRefreshButtonClick.bind(this)} />
                            <ToolBarSeparator />
                            <PopupProvider
                                id="template-contextmenu"
                                trigger={PopupTrigger.Click}
                                refPropName="elementRef">
                                <ToolBarItem
                                    icon="printer"
                                    text="Reports"
                                    title={`${templateCount === 0 ? "Keine Reports vorhanden" : ""}`}
                                    isDisabled={this.state.events == null || this.state.events.length === 0 || templateCount === 0} />
                            </PopupProvider>
                        </ToolBar>
                        {
                            isSearching &&
                            <Loader loaderStyle={LoaderStyle.style1} />
                        }
                        {!isSearching && this.getList()}
                    </div>
                </Flyout>

                <Popup id="list-contextmenu">
                    <ContextMenu>
                        <MenuItem
                            icon="arrow-top-right"
                            header="Öffnen"
                            onClick={this.onOpenEventMenuItemClick.bind(this)} />
                        <MenuItem
                            icon="calendar"
                            header="Im Kalender anzeigen"
                            isDisabled={(this.state.selectedEvent == null || this.state.selectedEvent.is_archived)}
                            onClick={this.onGotoEventMenuItemClick.bind(this)} />
                    </ContextMenu>
                </Popup>

                <Popup id="template-contextmenu">
                    <ContextMenu>
                        {this.getTemplates()}
                    </ContextMenu>
                </Popup>
            </div>
        );
    }
}